import { BoxProps, Box } from "@chakra-ui/react";

interface CardProps extends BoxProps {}

const Card = ({ children, ...rest }: CardProps) => {
  return (
    <Box
      borderRadius="16px"
      p={{ base: "0", xl: "1.5rem" }}
      bg="backgroundSecondary"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Card;
